<template>

<header class="innerHeader afterLoginHeader logBlk" v-if="authed">
  <!-- Navigation -->
  <div class="container">
    <div class="navbar navbar-default" role="navigation">
      <div class="navbar-header">
        <button v-on:click="toggleMenu" type="button" class="navbar-toggle"> <span class="sr-only">Toggle Navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button>
        <a class="navbar-brand" href="index.html">
        <div class="logo"> <img src="@/images/logo-inner.png" alt="logo" class="img-responsive"> </div>
        </a> </div>
      <div class="navbar-collapse">
        <ul class="nav navbar-nav navbar-right">
          <div class="Search">
            <input v-model="(product_name)" name="search" v-on:keyup.enter="search($event)" type="text" placeholder="Search">
          </div>
          <li><img class="img-responsive whiteThumb" src="@/images/products.png" alt=""><img class="img-responsive greyThumb" src="@/images/grey1.png" alt="">
            <a v-if="mode == 'spage'" v-on:click="goDirect($event, 'product')" href="javascript:void(0)">{{header_text.products}}</a>
            <a v-else href="javascript:void(0)" v-on:click="goProduct($event)">{{header_text.products}}</a>
            <!--
            <a v-else-if="pmode == 'shelf'" href="../pog/index.html">{{header_text.products}}</a>
            <a v-else href="../product/index.html">{{header_text.products}}</a>
            -->
          </li>
          <scart :mode="mode" :header_text="header_text"></scart>
          <li><img class="img-responsive whiteThumb" src="@/images/order.png" alt=""> <img class="img-responsive greyThumb" src="@/images/grey3.png" alt=""><a href="../order/index.html">{{header_text.order}}</a></li>
          <li><img class="img-responsive whiteThumb" src="@/images/profile.png" alt=""><img class="img-responsive greyThumb" src="@/images/grey4.png" alt=""><a href="../account/index.html">{{header_text.account}}</a> </li>
          <li><img class="img-responsive whiteThumb" src="@/images/logout.png" alt=""><img class="img-responsive greyThumb" src="@/images/grey5.png" alt=""><a href="javascript:void(0)" v-on:click="logout()">{{header_text.logout}}</a> </li>
          <li class="borderNone lang" v-if="locales.length>1">
            <div class="dropdown">
              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-globe"></i>
                <i class="fa fa-caret-down"></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li v-for="locale in locales"><a class="dropdown-item" href="javascript:void(0)" @click="goLocale(locale.id)">{{locale.name}}</a></li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- End Navigation--> 
</header>

<header :class="this.name=='index'?'innerHeader':'innerHeader'" v-else>
  <!-- Navigation -->
  <div class="container">
    <div class="navbar navbar-default" role="navigation">
      <div class="navbar-header">
        <button v-on:click="toggleMenu" type="button" class="navbar-toggle"> <span class="sr-only">Toggle Navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button>
        <a class="navbar-brand" href="index.html">
        <div class="logo"> <img src="@/images/logo-inner.png" alt="logo" class="img-responsive"> </div>
        </a> </div>
      <div class="navbar-collapse">
        <ul class="nav navbar-nav navbar-right">
          <li :class="name=='about'?'active':''"> <a :href="pageRoot + '/about.html'">{{header_text.aboutus}}</a> </li>
          <li :class="name=='reseller'?'active':''"> <a :href="pageRoot + '/reg.html'">{{header_text.reg}}</a> </li>
          <li :class="name=='reglogin'?'active':''"> <a :href="pageRoot + '/reglogin.html'">{{header_text.reglogin}}</a> </li>
          <!-- <li :class="name=='login'?'active':''"> <a href="#">Reseller Login</a> </li> -->
          <li :class="locales.length<=1?'borderNone':''"> <a :href="getShopUrl()">{{header_text.sampsonstore}}</a> </li>
          <li class="borderNone lang" v-if="locales.length>1">
            <div class="dropdown">
              <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fa fa-globe"></i>
                <i class="fa fa-caret-down"></i>
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <li v-for="locale in locales"><a class="dropdown-item" href="javascript:void(0)" @click="goLocale(locale.id)">{{locale.name}}</a></li>
                <!--li><a class="dropdown-item" href="javascript:void(0)" @click="goLocale('enus')">English</a></li>
                <li><a class="dropdown-item" href="javascript:void(0)" @click="goLocale('zhhk')">繁體中文</a></li>
                <li><a class="dropdown-item" href="javascript:void(0)" @click="goLocale('zhcn')">简体中文</a></li-->
              </ul>
            </div>
          </li>
          <div class="search" v-if="this.name=='index'">
          </div>
          <div class="search" v-else>
            <!--
            <input type="text" placeholder="Search">
               <dl id="sample" class="dropdown">
            <dt><a href="#"><span><img class="flag" src="@/images/select_dropdown.jpg" alt="" /> English</span></a></dt>
               <dd>
                  <ul>
                <li><a href="#"><img class="flag" src="@/images/select_dropdown.jpg" alt="" /> English<span class="value">BR</span></a></li>
                <li><a href="#"><img class="flag" src="http://www.jankoatwarpspeed.com/wp-content/uploads/examples/reinventing-drop-down/fr.png" alt="" /> France<span class="value">FR</span></a></li>
                  </ul>
                </dd>
             </dl>
            -->
          </div>
        </ul>
      </div>
    </div>
  </div>
  <!-- End Navigation-->
</header>
</template>

<script>

import utils from './Utils.vue'
import scart from './ShoppingCart.vue'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

export default {
  name: 'header',
  props:['mode', 'name', 'header_text', 'logon', 'authed'],
  data () {
    return {
      pmode:null,
      product_name:null
    }
  },
  created: function() {
    this.pmode = Vue.cookie.get('pmode');
    if (window.location.hash != '') {
      var pn = window.location.hash.substring(1);
      this.setSearch(pn);
    }
    this.$root.$on('afterSearch', data => {
      this.setSearch(data);
    });
    this.$root.$on('authed', data => {
      this.authed = true;
    });
  },
  components: {
    scart
  },
  mounted: function() {
  },
  computed: {
    pageRoot: function() {
      return utils.getPageRoot();
    },
    locales: function() {
      var locs = [];
      if (this.header_text == null) return locs;
      var hostname = utils.getHostname();
      if (this.header_text[hostname] != null) {
        Object.keys(this.header_text[hostname]).sort().forEach(itemKey => {
          if (itemKey.indexOf('locale_') == 0) {
            var k = itemKey.substring(7);
            var v = this.header_text[hostname][itemKey]; 
            locs.push({"id":k, "name":v});
          }
        });
      } else {
        Object.keys(this.header_text).sort().forEach(itemKey => {
          if (itemKey.indexOf('locale_') == 0) {
            var k = itemKey.substring(7);
            var v = this.header_text[itemKey]; 
            locs.push({"id":k, "name":v});
          }
        });
      }
      return locs;
    }
  },
  methods: {
    goProduct:function(evt) {
      this.pmode = Vue.cookie.get('pmode');
      if (this.pmode == 'shelf') {
        window.location.href='../pog/index.html'
      } else {
        window.location.href='../product/index.html'
      }
    },
    setSearch:function(pn) {
      if (pn.indexOf('n') == 0 && !isNaN(parseInt(pn.substring(1)))) {
        this.product_name = '';
      } else {
        this.product_name = decodeURIComponent(window.location.hash.substring(1));
      }
    },
    getShopUrl:function() {
      return "https://"+window.location.hostname;
    },
    
    logout:function(evt) {
      utils.restoreCart();
      //utils.cleanCart();
      Vue.http.get(utils.getServerPath()+'/reseller/logout.is').then(response => {
        var data = JSON.parse(response.bodyText);
        if (data.success == 0) {
          window.location.href = utils.getPageRoot() + '/reglogin.html';
        }
      });
    },
    goDirect:function(evt, name) {
      this.$root.$emit('godirect', name);
    },
    search:function(evt) {
      if (window.location.href.indexOf('/product/') > 0) {
        this.$root.$emit('search', this.product_name);
      } else {
        window.location.href='../product/index.html#'+this.product_name;
      }
    },
    goLocale:function(locale) {
      var cl = utils.getLocale();
      var search = window.location.search;
      var hash = window.location.hash;
      var l = window.location.href;
      var idx = search.indexOf('locale');
      if (idx > 0) {
        search = search.replace('locale='+cl, 'locale='+locale);
      } else if (search == '') {
        search = search + '?locale='+locale;
      } else {
        search = search + '&locale='+locale;
      }
      l = window.location.origin+window.location.pathname+search+hash;
      window.location.href = l;
    },
    toggleMenu:function() {
      $('.navbar-collapse').toggleClass('rightSideBar');
      $('.navbar-toggle').toggleClass('indexcity');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue